import {getMethod, putMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/api/excursions', request, cancelToken)
}

async function put(request) {
    return await putMethod('/api/excursions', request)
}

export {get, put}
